export const SOFTLINE_API_KUNDEN_KONDITIONSLISTE_LIST = '/v1/condition_sheet/list';
export const SOFTLINE_API_KUNDEN_KONDITIONSLISTE_INSERT = '/v1/condition_sheet/insert';
export const SOFTLINE_API_KUNDEN_KONDITIONSLISTE_PRINT = '/v1/condition_sheet/print/condition_sheet/pdf';
